import React from 'react';
import cn from 'classnames';

import { getTranslation } from 'helpers/getTranslation';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';
import { LinearProgressBar } from 'components/shared/LinearProgressBar';
import { Button } from 'components/shared/Button';

import { IMAGE_FORMAT_TAGS } from './UploadImageBlock.constants';

import styles from './UploadImageBlock.module.scss';

const UploadImageBlock = ({
  className,
  readOnly,
  loading,
  haveError,
  value,
  percentage,
  getInputProps,
  getRootProps,
  onRemoveClick,
  onBrowseClick,
}: {
  className: any;
  readOnly: any;
  loading: any;
  haveError: any;
  value: any;
  percentage: any;
  getInputProps: any;
  getRootProps: any;
  onRemoveClick: any;
  onBrowseClick: any;
}) => (
  <div
    {...getRootProps()}
    className={cn(
      styles.upload,
      { [styles.uploadWithValue]: !!value },
      { [styles.uploadHaveError]: haveError },
      { [styles.uploadReadOnly]: readOnly },
      className,
    )}
  >
    <input {...getInputProps()} className={styles.field} />
    {value && !loading && !readOnly && (
      <>
        <div className={styles.actionOverlay} />
        <Button
          className={styles.action}
          variant="ghost"
          mode="icon"
          size="md"
          iconName="trash"
          iconColor="#fff"
          onClick={onRemoveClick}
        />
      </>
    )}
    {value ? (
      <img src={value} className={styles.preview} />
    ) : (
      <>
        {percentage > 0 && percentage <= 100 ? (
          <LinearProgressBar variant="upload" progress={percentage} />
        ) : (
          <div className={styles.inner} onClick={!readOnly && onBrowseClick}>
            <div className={styles.main}>
              <Icon className={styles.icon} name="image" />
              <Typography
                className={styles.text}
                variant="body1"
                mode="compact"
                weight="medium"
              >
                {getTranslation('components.upload.add_image')}
              </Typography>
            </div>
            <div className={styles.tags}>
              {IMAGE_FORMAT_TAGS.map((tag: any) => (
                <div className={styles.tag}>
                  <Typography
                    className={styles.tagText}
                    variant="body3"
                    mode="compact"
                    weight="medium"
                  >
                    {tag}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    )}
  </div>
);

export default React.memo(UploadImageBlock) as any;
